import { gql } from '@apollo/client';
export const composerCategoriesQuery = gql `
  query ComposerCategories {
    categories(order_by: { order: asc }) {
      id
      metadata {
        id
        title
        marketLocaleCode: market_locale_code
      }
    }
  }
`;
